export default __webpack_public_path__ + "static/media/saturation-report-icon.fe45f9db.svg";